<template>
  <div>
    <b-card v-if="messageUpdate" class="my-3 update-notice">{{ messageUpdate }}</b-card>
    <b-card v-if="!isEditing" class="mb-4">
      <div class="d-grid gap-5">
        <b-row>
          <b-col md="4" class="text-gray-600">状態</b-col>
          <b-col md="8">{{ subsOrder.stateI18n }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">小計(税抜)</b-col>
          <b-col md="8">{{ subsOrder.subtotal }}円</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">自動注文発生件数 </b-col>
          <b-col md="8">無制限</b-col>
        </b-row>

        <!-- <b-row>
          <b-col md="4" class="text-gray-600">ポイント利用 </b-col>
          <b-col md="8"></b-col>
        </b-row> -->

        <b-row>
          <b-col md="4" class="text-gray-600">クーポンコード </b-col>
          <b-col md="8">{{ subsOrder.couponCode || "未使用" }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">支払い方法 </b-col>
          <b-col md="8">{{ subsOrder.paymentMethod }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">配送サイクル </b-col>
          <b-col md="8">{{ subsOrder.paymentScheduleI18n }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">何ヶ月ごとの何日に配送（日付指定） </b-col>
          <b-col md="8">{{ subsOrder.fullRecreateOrderDetail }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">お届け時間 </b-col>
          <b-col md="8">{{ subsOrder.scheduledDeliveryTime }}</b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="text-gray-600">次回配送予定日 </b-col>
          <b-col md="8"> {{ subsOrder.scheduledToBeDeliveredAt }}</b-col>
        </b-row>
        <b-row>
          <b-col md="4" class="text-gray-600">作成日</b-col>
          <b-col md="8">
            {{ filters.fullDateTime(subsOrder.createdAt) }}
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card v-if="isEditing" class="mb-4">
      <template #header>クーポンを使用</template>

      <template v-if="subsOrder.couponCode">
        <b-row class="align-items-center">
          <b-col md="4" class="text-gray-600">クーポンコード</b-col>
          <b-col md="8" class="d-flex align-items-center gap-3">
            <span>{{ subsOrder.couponCode }}（使用中）</span>
            <button type="button" class="btn btn-primary btn-sm" @click="confirmRemoveCoupon">外す</button>
          </b-col>
        </b-row>
      </template>

      <template v-else>
        <template v-if="subsOrder.availableCoupons && subsOrder.availableCoupons.length">
          <div class="fw-bold mb-2">ご利用可能なクーポン</div>
          <div
            v-for="coupon in subsOrder.availableCoupons"
            :key="coupon.id"
            class="border p-3 mb-3 d-flex align-items-start justify-content-between"
          >
            <div>
              <div class="fw-bold fs-6">{{ discountLabel(coupon) }}</div>
              <div class="mt-1">{{ expiryLabel(coupon) }}</div>
              <div class="mt-1">クーポン名: {{ coupon.name }}</div>
            </div>
            <button type="button" class="btn btn-dark btn-sm text-nowrap" @click="selectedCode = coupon.code">
              適用する
            </button>
          </div>
        </template>

        <div class="fw-bold mb-2">クーポンコードを入力してください。</div>
        <input
          type="text"
          class="form-control mb-3"
          v-model="selectedCode"
          placeholder="例）SALE2026"
        />
        <button type="button" class="btn btn-primary" @click="confirmSaveCoupon">保存</button>
      </template>
    </b-card>

    <div v-if="!isEditing && subsOrder.reactivable">
      <b-card class="my-5 reactive-notice"
        >定期を再開するには次回配送予定日を選択し、再開ボタンを押してください。
      </b-card>
      <b-card>
        <b-row class="mt-3">
          <b-col md="4" class="text-gray-600">
            <form-validator label="次回配送予定日" required />
          </b-col>
          <b-col md="8">
            <b-select
              v-model="reactiveScheduledToBeDeliveredAt"
              :options="reactiveScheduledToBeDeliveredAtOptions"
              class="form-control"
            />
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div v-if="!isEditing" class="d-flex justify-content-between mt-8">
      <a href="/shop/customer/subs_orders/" class="btn btn-dark mx-5"> 戻る </a>

      <div class="d-flex gap-3">
        <button
          v-if="subsOrder.state === 'active'"
          type="button"
          class="btn btn-primary"
          @click="isEditing = true"
        >
          編集
        </button>

        <button
          v-if="subsOrder.reactivable"
          class="btn btn-primary"
          @click="$emit('reactiveSubsOrder', reactiveScheduledToBeDeliveredAt)"
        >
          再開
        </button>

        <button v-if="subsOrder.cancelable" class="btn btn-danger" @click="cancelSuspendSubsOrder">
          停止
        </button>
      </div>
    </div>

    <div v-else class="mt-8">
      <button type="button" class="btn btn-dark mx-5" @click="isEditing = false">戻る</button>
    </div>

    <b-modal
      v-model="modalCancelShow"
      hide-header
      @ok="$emit('cancelSubsOrder')"
      ok-title="OK"
      cancel-title="取消"
      ok-variant="danger"
    >
      本当に停止しますか？
    </b-modal>

    <b-modal
      v-model="modalCouponShow"
      hide-header
      @ok="onCouponModalOk"
      ok-title="OK"
      cancel-title="取消"
    >
      {{ couponModalMessage }}
    </b-modal>
  </div>
</template>

<script lang="ts" setup>
import filters from "@/composables/filters";
import { computed, ref, watch } from "vue";
import { useBaseInfoStore } from "@/stores/base_info";
import { useSubsOrdersStore } from "@/stores/customer/subsOrders";

import { CustomersSubsOrderType } from "@/types/customers/CustomersSubsOrderType";

interface Props {
  subsOrder: CustomersSubsOrderType;
  messageUpdate: string | null;
}

const props = defineProps<Props>();

const isEditing = ref(false);
const modalCancelShow = ref(false);
const modalCouponShow = ref(false);
const couponModalMessage = ref("");
const pendingCouponCode = ref("");
const reactiveScheduledToBeDeliveredAt = ref("");

const baseInfoStore = useBaseInfoStore();
const subsOrdersStore = useSubsOrdersStore();

const baseInfo = computed(() => baseInfoStore.baseInfo);

const reactiveScheduledToBeDeliveredAtOptions = computed(() => {
  const options = props.subsOrder.reactiveScheduledToBeDeliveredAtOptions || [];

  if (options.length && !props.subsOrder.scheduledToBeDeliveredAt)
    reactiveScheduledToBeDeliveredAt.value = options[0].value;
  else {
    const includeScheduledToBeDeliveredAt = options
      .map((item) => item.value)
      .includes(props.subsOrder.scheduledToBeDeliveredAt);

    reactiveScheduledToBeDeliveredAt.value = includeScheduledToBeDeliveredAt
      ? props.subsOrder.scheduledToBeDeliveredAt
      : options[0].value;
  }

  return options || [];
});

const emit = defineEmits(["cancelSubsOrder", "reactiveSubsOrder", "updateSubsOrderCoupon"]);

const discountLabel = (coupon: { discountAmount: number | null; discountRatio: number | null }) => {
  if (coupon.discountAmount) return `${coupon.discountAmount}円 OFF`;
  if (coupon.discountRatio) return `${coupon.discountRatio}% OFF`;
  return "";
};

const expiryLabel = (coupon: { eDate: string | null }) => {
  if (!coupon.eDate) return "無期限";

  const date = new Date(coupon.eDate);
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}まで有効`;
};

function confirmSaveCoupon() {
  pendingCouponCode.value = selectedCode.value;
  couponModalMessage.value = "クーポンを適用しますか？";
  modalCouponShow.value = true;
}

function confirmRemoveCoupon() {
  pendingCouponCode.value = "";
  couponModalMessage.value = "クーポンを外しますか？";
  modalCouponShow.value = true;
}

function onCouponModalOk() {
  emit("updateSubsOrderCoupon", pendingCouponCode.value);
}

function cancelSuspendSubsOrder() {
  if (baseInfo.value?.subsOrderCancelableReason) {
    subsOrdersStore.cancelable = true;

    window.location.href = "/shop/customer/subs_orders/" + props.subsOrder.number + "/cancel";
  } else {
    modalCancelShow.value = true;
  }
}

const selectedCode = ref(props.subsOrder.couponCode || "");

watch(
  () => props.subsOrder.couponCode,
  (value) => {
    selectedCode.value = value || "";
  }
);
</script>

<style scoped>
.update-notice {
  background-color: #dff0d8;
}
.reactive-notice {
  background-color: #d9edf7;
}
</style>
